export var StateWindowVisibility;
(function (StateWindowVisibility) {
    StateWindowVisibility["Hidden"] = "hidden";
    StateWindowVisibility["Visible"] = "visible";
    StateWindowVisibility["PreRender"] = "prerender";
})(StateWindowVisibility || (StateWindowVisibility = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/window-visibility/StateWindowVisibility.ts
// module id = 798
// module chunks = 3